import Vue from "vue";
import Router from "vue-router";
import module from "./module";
import Index from "@views/home/Index";
import Search from "@views/shop/GoodSearch";
import Category from "@views/shop/GoodsClass";
import ShoppingCart from "@views/shop/ShoppingCart";
import GoodsList from "@views/shop/GoodsList";
import NotDefined from "@views/NotDefined";
import $store from "../store";
import toLogin from "@libs/login";
import Loading from "@views/Loading";
import WxBase from "@views/user/WxBase";
import cookie from "@utils/store/cookie";
import PdfViewer from '@/views/pdf/PdfViewer.vue';
import SimplePdfViewer from '@/views/pdf/SimplePdfViewer.vue';
import DetailsAdmin from '@/views/DetailsAdmin.vue';

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/shop/storeList/:gonames?",
      name: "StoreList",
      meta: {
        title: "门店列表",
        keepAlive: false,
      },
      component: () => import("@views/shop/StoreList.vue"),
    },
    {
      path: "/",
      name: "Index",
      meta: {
        title: "首页",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff",
      },
      component: Index,
    },
    {
      path: "/category/:pid?",
      name: "GoodsClass",
      meta: {
        title: "产品分类",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff",
      },
      component: Category,
    },
    {
      path: "/collection",
      name: "GoodsCollection",
      meta: {
        title: "收藏教练",
        keepAlive: false,
        auth: true,
      },
      component: () => import("@views/shop/GoodsCollection.vue"),
    },

    {
      path: "/foot",
      name: "GoodsFoot",
      meta: {
        title: "收藏教练",
        keepAlive: false,
        auth: true,
      },
      component: () => import("@views/shop/GoodsFoot.vue"),
    },
    {
      path: "/search",
      name: "GoodSearch",
      meta: {
        title: "搜索教练",
        keepAlive: true,
        backgroundColor: "#fff",
      },
      component: Search,
    },
    {
      path: "/news_detail/:id",
      name: "NewsDetail",
      meta: {
        title: "新闻详情",
        keepAlive: false,
        backgroundColor: "#fff",
      },
      component: () => import("@views/shop/news/NewsDetail.vue"),
    },
    {
      path: "/news_list",
      name: "NewsList",
      meta: {
        title: "新闻",
        keepAlive: true,
        backgroundColor: "#fff",
      },
      component: () => import("@views/shop/news/NewsList.vue"),
    },
    {
      path: "/view_detail/:id",
      name: "viewDetail",
      meta: {
        title: "",
        keepAlive: true,
        backgroundColor: "#fff",
      },
      component: () => import("@views/shop/news/Agreement.vue"),
    },
    {
      path: "/evaluate_list/:id",
      name: "EvaluateList",
      meta: {
        title: "教练评分",
        keepAlive: false,
        auth: true,
      },
      component: () => import("@views/shop/EvaluateList.vue"),
    },
    {
      path: "/goods_evaluate/:id",
      name: "GoodsEvaluate",
      meta: {
        title: "教练评价",
        keepAlive: false,
        auth: true,
      },
      component: () => import("@views/shop/GoodsEvaluate.vue"),
    },
    {
      path: "/promotion",
      name: "GoodsPromotion",
      meta: {
        title: "促销单品",
        keepAlive: false,
      },
      component: () => import("@views/shop/GoodsPromotion.vue"),
    },
    {
      path: "/hot_new_goods/:type",
      name: "HotNewGoods",
      meta: {
        title: "热门榜单",
        keepAlive: false,
      },
      component: () => import("@views/shop/HotNewGoods.vue"),
    },
    {
      path: "/detail/:id",
      name: "GoodsCon",
      meta: {
        title: "教练详情",
        keepAlive: false,
        auth: false,
      },
      component: () => import("@views/shop/GoodsCon.vue"),
    },
    {
      path: "/cart",
      name: "ShoppingCart",
      meta: {
        title: "购物车",
        keepAlive: true,
        footer: true,
        auth: true,
      },
      component: ShoppingCart,
    },
    {
      path: "/goods_list",
      name: "GoodsList",
      meta: {
        title: "教练列表",
        keepAlive: true,
      },
      component: GoodsList,
    },
    {
      path: "/login",
      name: "Login",
      meta: {
        title: "登录",
        keepAlive: true,
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/Login.vue"),
    },
    {
      path: "/test_login",
      name: "TestLogin",
      meta: {
        title: "登录",
        keepAlive: true,
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/TestLogin.vue"),
    },
    {
      path: "/coach_login",
      name: "CoachLogin",
      meta: {
        title: "教练登录",
        keepAlive: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "CoachLogin" */ "@views/user/CoachLogin.vue"
        ),
    },
    {
      path: "/forget",
      name: "Forget",
      meta: {
        title: "找回密码",
        keepAlive: true,
      },
      component: () =>
        import(/* webpackChunkName: "CoachLogin" */ "@views/user/Forget.vue"),
    },
    {
      path: "/settle_in",
      name: "SettleIn",
      meta: {
        title: "教练入驻",
        keepAlive: false,
      },
      component: () =>
        import(/* webpackChunkName: "SettleIn" */ "@views/user/SettleIn.vue"),
    },
    ...module,
    {
      path: "/auth/:url",
      name: "Loading",
      meta: {
        title: " 加载中",
        keepAlive: true,
      },
      component: Loading,
    },
    {
      path: "*",
      name: "NotDefined",
      meta: {
        title: "页面找不到",
        keepAlive: true,
        home: false,
        backgroundColor: "#F4F6FB",
      },
      component: NotDefined,
    },
    {
      path: "/wxBase",
      name: "wxBase",
      meta: {
        title: "首页",
        keepAlive: true,
      },
      component: WxBase,
    },
    {
      path: "/pdf/viewer",
      name: "PdfViewer",
      component: PdfViewer,
      meta: {
        title: "合同查看"
      }
    },
    {
      path: "/pdf/simple-viewer",
      name: "SimplePdfViewer",
      component: SimplePdfViewer,
      meta: {
        title: "合同查看"
      }
    },
    {
      path: "/detailsAdmin",
      name: "DetailsAdmin",
      meta: {
        title: "管理员提示",
        keepAlive: false,
      },
      component: DetailsAdmin,
    },
  ],
  scrollBehavior(to, from) {
    from.meta.scrollTop = window.scrollY;
    return { x: 0, y: to.meta.scrollTop || 0 };
  },
});

const { back, replace } = router;

router.back = function () {
  this.isBack = true;
  back.call(router);
};
router.replace = function (...args) {
  this.isReplace = true;
  replace.call(router, ...args);
};

router.beforeEach((to, from, next) => {
  // console.log(to, form);
  cookie.set('preRouter', from.fullPath)
  const { title, backgroundColor, auth } = to.meta;
  if (auth === true && !$store.state.app.token) {
    // 记录上一层的路由
    if (from.name === "Login") return;
    return toLogin(true, to.fullPath);
  }
  document.title = title || process.env.VUE_APP_NAME || "蒲公英教练";
  $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5");
  if (auth) {
    $store.dispatch("USERINFO").then(() => {
      next();
    });
  } else next();
});

export default router;
